var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSideBarMenuContainerPlatformCluster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "ww3whehuaa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.275000 0 0 0 0 0.327941 0 0 0 0 0.500000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -11)",
    filter: "url(#ww3whehuaa)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.5 19 6-2v15l-6-2zM25.5 17l15 2.5v10l-15 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M29 20v9M32 20.5v8M35 21v7M38 21.5v6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSideBarMenuContainerPlatformCluster);
export default __webpack_public_path__ + "static/media/ico-side-bar-menu-container-platform-cluster.bc7d01da8d33225934117aa0845e2ad2.svg";
export { ForwardRef as ReactComponent };